/**
 * getQuiz.js
 * Written by: Alex Kasemir
 */
import questionActions from '../../../question/actions';
import resultActions from '../../../result/actions';
import request from '../../../request/actions';

export const GET_QUIZ_START = `GET_QUIZ_START`;
export const GET_QUIZ_SUCCESS = `GET_QUIZ_SUCCESS`;
export const GET_QUIZ_FAILURE = `GET_QUIZ_FAILURE`;

export const getQuizStart = (id) => ({
  type: GET_QUIZ_START,
  id,
});

export const getQuizSuccess = (id, quiz, hasAttempted) => ({
  type: GET_QUIZ_SUCCESS,
  quiz,
  id,
  hasAttempted,
});

export const getQuizFailure = (error) => ({
  type: GET_QUIZ_FAILURE,
  error,
});

/**
 * Description of the getQuiz action
 */

export const getQuiz = (id, hasAttempted) => {
  return async (dispatch, getState) => {
    dispatch(getQuizStart(id));
    if (!getState().user.JWT) {
      dispatch(questionActions.clearQuestionsMeta());
      dispatch(resultActions.clearResults(getState().result.selected));
    }
    try {
      const response = await dispatch(request(`/quizzes/${id}/`, `GET`));
      dispatch(getQuizSuccess(response.data.id, response.data, hasAttempted));
      return response.data;
    } catch (error) {
      dispatch(getQuizFailure(error));
      return error;
    }
  };
};

export default getQuiz;
